module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/crypto-app-5-48dbe5db1a87ec12dfe914a856a30c4e.png";